<template>
    <div class="delete-match-form should-dim modify-form">
        <div>
            Are you sure you want to delete this match?
        </div>
        <div class="">
            <small v-show="error"><span class="text-danger">{{ errorMessage }}</span></small>
            <br/>
            <button v-on:click="hideMatchDeleteForm" class="btn btn-default">Cancel</button>
            <ladda-button @lbClicked="deleteMatchPressed" el-class="btn-danger" :loading="loading">
                Yes, Delete
            </ladda-button>
        </div>
    </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';

export default {
  name: 'delete-match-form',
  components: { LaddaButton },
  props: [
    'match',
  ],
  data() {
    return {
      loading: false, // Loading is a network variable (hitting the api)

      error: false,
      errorMessage: 'Error, please try again later or contact support.',
    };
  },
  methods: {
    hideMatchDeleteForm() {
      const vm = this;
      vm.$notificationManager.emit('hide-delete-match-form', vm.match);
    },
    deleteMatchPressed: _.throttle(function () {
      const vm = this;
      // If this is a duplicate request, just return
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;

      const url = vm.$apiService.matchUrl(vm.match.id);
      axios.delete(url)
        .then((response) => {
          vm.loading = false;

          vm.$notificationManager.emit('show-toast', 'Match deleted', true);
          vm.$notificationManager.emit('match-deleted', vm.match);
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = 'Error, please try again later or contact support.';
          vm.error = true;
        });
    }, 500),
  },
};
</script>
